Ext.override(Ext.form.TextField, {
    _validateValue: Ext.form.TextField.prototype.validateValue,
    validateValue: function(v) {
        if (v.trim) {
            arguments[0] = v.trim();
        }
        return Ext.form.TextField.prototype._validateValue.apply(this, arguments);
    },
    filterKeys: function(e) {
        if (e.ctrlKey) {
            return;
        }
        var k = e.getKey();
        var flag = Ext.isGecko || Ext.isOpera;
        if (flag && (e.isNavKeyPress() || k == e.BACKSPACE || (k == e.DELETE && e.button == -1))) {
            return;
        }
        var c = e.getCharCode(),
            cc = String.fromCharCode(c);
        if (!flag && e.isSpecialKey() && !cc) {
            return;
        }
        if (!this.maskRe.test(cc)) {
            e.stopEvent();
        }
    },
});

if (Ext.ux && Ext.ux.form && Ext.ux.form.DateTime) {
    Ext.override(Ext.ux.form.DateTime, {
        getValue: function() {
            this.updateValue();
            return this.dateValue ? new Date(this.dateValue) : '';
        },
    });
}

Ext.Layer.prototype.afterFx = function() {
    Ext.Layer.superclass.afterFx.apply(this, arguments);
    if (this.dom.parentNode) {
        //don't sync detached windows
        this.sync(this.isVisible());
    }
};

Ext.override(Ext.data.HttpProxy, {
    load: function(params, reader, callback, scope, arg, conn) {
        if (this.fireEvent('beforeload', this, params) !== false) {
            var o = {
                params: params || {},
                request: {
                    callback: callback,
                    scope: scope,
                    arg: arg,
                },
                reader: reader,
                callback: this.loadResponse,
                scope: this,
            };
            if (this.useAjax) {
                Ext.apply(o, conn || {});
                Ext.applyIf(o, this.conn);
                if (this.activeRequest) {
                    Ext.Ajax.abort(this.activeRequest);
                }
                this.activeRequest = Ext.Ajax.request(o);
            } else {
                this.conn.request(o);
            }
        } else {
            callback.call(scope || this, null, arg, false);
        }
    },
});

Ext.override(Ext.Panel, {
    createElement: function(name, pnode) {
        if (this[name] && this[name].dom) {
            pnode.appendChild(this[name].dom);
            return;
        }

        if (name === 'bwrap' || this.elements.indexOf(name) != -1) {
            if (this[name + 'Cfg']) {
                this[name] = Ext.fly(pnode).createChild(this[name + 'Cfg']);
            } else {
                var el = document.createElement('div');
                el.className = this[name + 'Cls'];
                this[name] = Ext.get(pnode.appendChild(el));
            }
            if (this[name + 'CssClass']) {
                this[name].addClass(this[name + 'CssClass']);
            }
            if (this[name + 'Style']) {
                this[name].applyStyles(this[name + 'Style']);
            }
        }
    },
});

Ext.override(Ext.form.CheckboxGroup, {
    hideInnerLabel: true,

    innerLabelWidth: 105,

    innerLabelAlign: 'left',

    onRender: function(ct, position) {
        if (!this.el) {
            var panelCfg = {
                cls: this.groupCls,
                layout: 'column',
                border: false,
                renderTo: ct,
            };
            var defaults =
                this.hideInnerLabel === null ? {anchor: '100%'} : {hideLabel: this.hideInnerLabel, anchor: '100%'};
            var colCfg = {
                defaultType: this.defaultType,
                layout: 'mx-form',
                border: false,
                labelWidth: this.innerLabelWidth,
                labelAlign: this.innerLabelAlign,
                defaults: defaults,
            };

            if (this.items[0] && this.items[0].items) {
                Ext.apply(panelCfg, {
                    layoutConfig: {columns: this.items.length},
                    defaults: this.defaults,
                    items: this.items,
                });
                for (var i = 0, len = this.items.length; i < len; i++) {
                    Ext.applyIf(this.items[i], colCfg);
                }
            } else {
                var numCols,
                    cols = [];

                if (typeof this.columns == 'string') {
                    this.columns = this.items.length;
                }
                if (!Ext.isArray(this.columns)) {
                    var cs = [];
                    for (var i = 0; i < this.columns; i++) {
                        cs.push((100 / this.columns) * 0.01);
                    }
                    this.columns = cs;
                }

                numCols = this.columns.length;

                for (var i = 0; i < numCols; i++) {
                    var cc = Ext.apply({items: []}, colCfg);
                    cc[this.columns[i] <= 1 ? 'columnWidth' : 'width'] = this.columns[i];
                    if (this.defaults) {
                        cc.defaults = Ext.apply(cc.defaults || {}, this.defaults);
                    }
                    cols.push(cc);
                }
                if (this.vertical) {
                    var rows = Math.ceil(this.items.length / numCols),
                        ri = 0;
                    for (var i = 0, len = this.items.length; i < len; i++) {
                        if (i > 0 && i % rows == 0) {
                            ri++;
                        }
                        if (this.items[i].fieldLabel) {
                            this.items[i].hideLabel = false;
                        }
                        cols[ri].items.push(this.items[i]);
                    }
                } else {
                    for (var i = 0, len = this.items.length; i < len; i++) {
                        var ci = i % numCols;
                        if (this.items[i].fieldLabel) {
                            this.items[i].hideLabel = false;
                        }
                        cols[ci].items.push(this.items[i]);
                    }
                }

                Ext.apply(panelCfg, {
                    layoutConfig: {columns: numCols},
                    items: cols,
                });
            }

            this.panel = new Ext.Panel(panelCfg);
            this.el = this.panel.getEl();

            if (this.forId && this.itemCls) {
                var l = this.el.up(this.itemCls).child('label', true);
                if (l) {
                    l.setAttribute(Ext.isIE ? 'htmlFor' : 'for', this.forId);
                }
            }

            var fields = this.panel.findBy(function(c) {
                return c.isFormField;
            }, this);

            this.items = new Ext.util.MixedCollection();
            this.items.addAll(fields);
        }
        Ext.form.CheckboxGroup.superclass.onRender.call(this, ct, position);
    },

    isDirty: function() {
        var dirty = false;
        this.items.each(function(f) {
            if (f.isDirty()) {
                dirty = true;
                return false;
            }
        });
        return dirty;
    },
});

Ext.override(Ext.form.Label, {
    onRender: function(ct, position) {
        if (!this.el) {
            this.el = document.createElement('label');
            this.el.id = this.getId();
            this.el.innerHTML = this.text ? Ext.util.Format.htmlEncode(this.text) : this.html || '';
            if (this.forId) {
                this.el.setAttribute(Ext.isIE ? 'htmlFor' : 'for', this.forId);
            }
        }
        Ext.form.Label.superclass.onRender.call(this, ct, position);
    },
});

Ext.override(Ext.form.ComboBox, {
    initEvents: function() {
        Ext.form.ComboBox.superclass.initEvents.call(this);
        this.keyNav = new Ext.KeyNav(this.el, {
            up: function(e) {
                this.inKeyMode = true;
                this.selectPrev();
            },
            down: function(e) {
                if (!this.isExpanded()) {
                    this.onTriggerClick();
                } else {
                    this.inKeyMode = true;
                    this.selectNext();
                }
            },
            enter: function(e) {
                this.onViewClick();
                this.delayedCheck = true;
                this.unsetDelayCheck.defer(10, this);
            },
            esc: function(e) {
                this.collapse();
            },
            tab: function(e) {
                this.onViewClick(false);
                return true;
            },
            scope: this,
            doRelay: function(foo, bar, hname) {
                if (hname == 'down' || this.scope.isExpanded()) {
                    return Ext.KeyNav.prototype.doRelay.apply(this, arguments);
                }
                return true;
            },
            forceKeyDown: true,
        });
        this.queryDelay = Math.max(this.queryDelay || 10, this.mode == 'local' ? 10 : 250);
        this.dqTask = new Ext.util.DelayedTask(this.initQuery, this);
        if (this.typeAhead) {
            this.taTask = new Ext.util.DelayedTask(this.onTypeAhead, this);
        }
        if (this.editable !== false && !this.enableKeyEvents) {
            this.el.on('keyup', this.onKeyUp, this);
        }
        if (this.forceSelection) {
            this.on('blur', this.doForce, this);
        }
    },
});

Ext.util.JSON = new function() {
    var useHasOwn = !!{}.hasOwnProperty;

    var pad = function(n) {
        return n < 10 ? '0' + n : n;
    };

    var m = {
        '\b': '\\b',
        '\t': '\\t',
        '\n': '\\n',
        '\f': '\\f',
        '\r': '\\r',
        '"': '\\"',
        '\\': '\\\\',
    };

    var encodeString = function(s) {
        if (/["\\\x00-\x1f]/.test(s)) {
            return (
                '"' +
                s.replace(/([\x00-\x1f\\"])/g, function(a, b) {
                    var c = m[b];
                    if (c) {
                        return c;
                    }
                    c = b.charCodeAt();
                    return '\\u00' + Math.floor(c / 16).toString(16) + (c % 16).toString(16);
                }) +
                '"'
            );
        }
        return '"' + s + '"';
    };

    var encodeArray = function(o) {
        var a = ['['],
            b,
            i,
            l = o.length,
            v;
        for (i = 0; i < l; i += 1) {
            v = o[i];
            switch (typeof v) {
                case 'undefined':
                case 'function':
                case 'unknown':
                    break;
                default:
                    if (b) {
                        a.push(',');
                    }
                    a.push(v === null ? 'null' : Ext.util.JSON.encode(v));
                    b = true;
            }
        }
        a.push(']');
        return a.join('');
    };

    this.encodeDate = function(o) {
        return o.valueOf();
    };

    this.encode = function(o) {
        if (typeof o == 'undefined' || o === null) {
            return 'null';
        } else if (Ext.isArray(o)) {
            return encodeArray(o);
        } else if (Ext.isDate(o)) {
            return Ext.util.JSON.encodeDate(o);
        } else if (typeof o == 'string') {
            return encodeString(o);
        } else if (typeof o == 'number') {
            return isFinite(o) ? String(o) : 'null';
        } else if (typeof o == 'boolean') {
            return String(o);
        } else {
            var a = ['{'],
                b,
                i,
                v;
            if (o instanceof Ext.data.Record) {
                o = o.data;
            }
            for (i in o) {
                if (!useHasOwn || o.hasOwnProperty(i)) {
                    v = o[i];
                    switch (typeof v) {
                        case 'undefined':
                        case 'function':
                        case 'unknown':
                            break;
                        default:
                            if (b) {
                                a.push(',');
                            }
                            a.push(this.encode(i), ':', v === null ? 'null' : this.encode(v));
                            b = true;
                    }
                }
            }
            a.push('}');
            return a.join('');
        }
    };

    this.decode = function(json) {
        if (!json) {
            return null;
        }
        return eval('(' + json.replace(/<\/?pre.*?>/gi, '') + ')'); //fix for chrome
        //        was: return eval("(" + json.replace(/<\/?pre>/ig, '') + ')');
    };
}();

Ext.encode = Ext.util.JSON.encode;

Ext.decode = Ext.util.JSON.decode;

Ext.apply(Ext.form.VTypes, {
    numbers: function(v) {
        return /^[0-9]+$/.test(v);
    },
    numbersText: 'Must be a numeric',
});

Ext.override(Ext.Element, {
    maskZerozIndex: function(msg, msgCls) {
        if (this.getStyle('position') == 'static') {
            this.setStyle('position', 'relative');
        }
        if (this._maskMsg) {
            this._maskMsg.remove();
        }
        if (this._mask) {
            this._mask.remove();
        }

        this._mask = Ext.DomHelper.append(this.dom, {cls: 'ext-el-mask', style: 'z-index: 0;'}, true);

        this.addClass('x-masked');
        this._mask.setDisplayed(true);
        if (typeof msg == 'string') {
            this._maskMsg = Ext.DomHelper.append(
                this.dom,
                {cls: 'ext-el-mask-msg', style: 'z-index: 0;', cn: {tag: 'div'}},
                true
            );
            var mm = this._maskMsg;
            mm.dom.className = msgCls ? 'ext-el-mask-msg ' + msgCls : 'ext-el-mask-msg';
            mm.dom.firstChild.innerHTML = msg;
            mm.setDisplayed(true);
            mm.center(this);
        }
        if (Ext.isIE && !(Ext.isIE7 && Ext.isStrict) && this.getStyle('height') == 'auto') {
            this._mask.setSize(this.dom.clientWidth, this.getHeight());
        }
        return this._mask;
    },
    maskCustom: function(cls, msg, msgCls) {
        var classMask = cls || 'mx-el-mask-empty';
        if (this.getStyle('position') == 'static') {
            this.setStyle('position', 'relative');
        }
        if (this._maskMsg) {
            this._maskMsg.remove();
        }
        if (this._mask) {
            this._mask.remove();
        }

        this._mask = Ext.DomHelper.append(this.dom, {cls: classMask, style: 'z-index: 0;'}, true);

        this.addClass('x-masked');
        this._mask.setDisplayed(true);
        if (typeof msg == 'string') {
            this._maskMsg = Ext.DomHelper.append(
                this.dom,
                {cls: 'ext-el-mask-msg', cn: {tag: 'div'}, style: 'z-index: 0;'},
                true
            );
            var mm = this._maskMsg;
            mm.dom.className = msgCls ? 'ext-el-mask-msg ' + msgCls : 'ext-el-mask-msg';
            mm.dom.firstChild.innerHTML = msg;
            mm.setDisplayed(true);
            mm.center(this);
        }
        if (Ext.isIE && !(Ext.isIE7 && Ext.isStrict) && this.getStyle('height') == 'auto') {
            this._mask.setSize(this.dom.clientWidth, this.getHeight());
        }
        return this._mask;
    },
});

Ext.form.TriggerField.override({
    afterRender: function() {
        Ext.form.TriggerField.superclass.afterRender.call(this);
    },
});

Ext.grid.ColumnModel.defaultRenderer = function(value) {
    var result = value;
    if (typeof value == 'string') {
        if (value.length < 1) {
            result = '&#160;';
        } else {
            result = Ext.util.Format.htmlEncode(value);
        }
    }
    return result;
};

Ext.grid.GridView.prototype.onRowOver = function(e, t) {
    var row = this.findRowIndex(t);
    if (row !== false && row < this.getRows().length) {
        this.addRowClass(row, 'x-grid3-row-over');
    }
};

Ext.override(Ext.grid.GridView, {
    processRows: function(startRow, skipStripe) {
        if (!this.ds || this.ds.getCount() < 1) {
            return;
        }
        skipStripe = skipStripe || !this.grid.stripeRows;
        startRow = startRow || 0;
        var rows = this.getRows();
        var cls = ' x-grid3-row-alt ';
        rows[0].className += ' x-grid3-row-first';
        rows[rows.length - 1].className += ' x-grid3-row-last';
        for (var i = startRow, len = rows.length; i < len; i++) {
            var row = rows[i];
            row.rowIndex = i;
            if (!skipStripe) {
                var isAlt = (i + 1) % 2 == 0;
                var hasAlt = (' ' + row.className + ' ').indexOf(cls) != -1;
                if (isAlt == hasAlt) {
                    continue;
                }
                if (isAlt) {
                    row.className += ' x-grid3-row-alt';
                } else {
                    row.className = row.className.replace('x-grid3-row-alt', '');
                }
            }
        }
    },
});
Ext.override(Ext.grid.GroupingView, {
    renderRows: function() {
        if (!this.cm) {
            return;
        }
        var groupField = this.getGroupField();
        var eg = !!groupField;
        // if they turned off grouping and the last grouped field is hidden
        if (this.hideGroupedColumn) {
            var colIndex = this.cm.findColumnIndex(groupField);
            if (!eg && this.lastGroupField !== undefined) {
                this.mainBody.update('');
                this.cm.setHidden(this.cm.findColumnIndex(this.lastGroupField), false);
                delete this.lastGroupField;
            } else if (eg && this.lastGroupField === undefined) {
                this.lastGroupField = groupField;
                this.cm.setHidden(colIndex, true);
            } else if (eg && this.lastGroupField !== undefined && groupField !== this.lastGroupField) {
                this.mainBody.update('');
                var oldIndex = this.cm.findColumnIndex(this.lastGroupField);
                this.cm.setHidden(oldIndex, false);
                this.lastGroupField = groupField;
                this.cm.setHidden(colIndex, true);
            }
        }
        return Ext.grid.GroupingView.superclass.renderRows.apply(this, arguments);
    },
});
Ext.override(Ext.menu.Menu, {
    autoWidth: function() {
        var el = this.el,
            ul = this.ul;
        if (!el) {
            return;
        }
        var w = this.width;
        if (w) {
            el.setWidth(w);
        } else if (Ext.isIE && !Ext.isIE8) {
            el.setWidth(this.minWidth);
            var t = el.dom.offsetWidth; // force recalc
            el.setWidth(ul.getWidth() + el.getFrameWidth('lr'));
        }
    },
});

Ext.override(Ext.data.Store, {
    findByValue: function(key, value) {
        return this.find(key, new RegExp('^' + value + '$'));
    },
});
/*
Ext.override(Ext.Element, {
    contains : function(el){
        try {
            return !el ? false : D.isAncestor(this.dom, el.dom ? el.dom : el);
        } catch(e) {
            return false;
        }
    }
});*/

//TODO: instead of following 3 fixes fix findRowIndex: it can find row from an alien grid
Ext.EventObjectImpl.prototype.within = function(el, related, allowEl) {
    var t = this[related ? 'getRelatedTarget' : 'getTarget']();
    return el && t && ((allowEl ? t === Ext.getDom(el) : false) || Ext.fly(el).contains(t));
};

Ext.grid.GridView.prototype.onRowOver = function(e, t) {
    var row;
    if ((row = this.findRowIndex(t)) !== false) {
        this.addRowClass(row, 'x-grid3-row-over', t);
    }
};

Ext.grid.GridView.prototype.addRowClass = function(row, cls, rowElement) {
    var r = this.getRow(row);
    if (rowElement) {
        while (rowElement && rowElement.parentNode != r) {
            rowElement = rowElement.parentNode;
        }
        if (!rowElement) {
            return; //its not the target grid
        }
    }
    if (r) {
        this.fly(r).addClass(cls);
    }
};

Ext.override(Ext.data.Connection, {
    timeout: MXAT.client_timeout || 60000,
});
Ext.override(Ext.grid.GridView, {
    syncFocusEl: function(row, col, hscroll) {
        try {
            var xy = row;
            if (!Ext.isArray(xy)) {
                row = Math.min(row, Math.max(0, this.getRows().length - 1));
                xy = this.getResolvedXY(this.resolveCell(row, col, hscroll));
            }
            this.focusEl.setXY(xy || this.scroller.getXY());
        } catch (ex) {
            // very dirty hack to fix IE "unspecified error"s
            // (trying to fuss with elements that do not exists in dom tree)
            // (other browsers are fine with it)
        }
    },
    scrollToTop: function() {
        try {
            this.scroller.dom.scrollTop = 0;
            this.scroller.dom.scrollLeft = 0;
        } catch (ex) {
            // very dirty hack to fix IE "unspecified error"s
            // (trying to fuss with elements that do not exists in dom tree)
            // (other browsers are fine with it)
        }
    },
});
